import { createEntityQuery } from '../../createEntityQuery';
import {
  TransactionService,
  type Wealthlane_AwardService_Dtos_Transactions_TransactionDto,
} from '@wealthlane/api-services/wealthlane-award-service';

export type ExtraTransactionDto = Wealthlane_AwardService_Dtos_Transactions_TransactionDto;

const useExtraTransactionQuery = createEntityQuery<ExtraTransactionDto, string>({
  queryKey: ['extraTransactionById'],
  queryFn: (transactionId) =>
    TransactionService.getApiAwardApiAppTransactionTransactionById(transactionId!),
  silent: true,
});

/**
 * Extended transaction financial fields by transaction ID.
 * Shared across award types (Options, SAR, etc.).
 * SAR transaction tab: pass `intentTransactionId ?? transactionId` as the effective ID.
 */
export function useGetExtraTransactionById(
  transactionId: string | undefined,
  enabled = true,
) {
  return useExtraTransactionQuery(transactionId as string, {
    enabled: Boolean(transactionId) && enabled,
  });
}
